export const DRAG_OVERLAY = "x-drag-overlay";
export const DRAG_OVERLAY_WRAPPER = "x-drag-overlay-wrapper";
export const DRAG_OVERLAY_CLOSE = "x-drag-overlay-close";
export const ITEM_DRAGGING = "x-dragging";
